"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _lodash = require("lodash");
const DropdownMergeTag = ({
  val,
  attributes
}) => {
  const {
    choices
  } = attributes;
  const mergedChoices = val.map(item => {
    const choiceIndex = choices.findIndex(a => a.value === item);
    let choiceLabel = 'Choice ' + (choiceIndex + 1);
    if (choices[choiceIndex].label) {
      choiceLabel = choices[choiceIndex].label;
    }
    return choiceLabel;
  });
  return (0, _react.createElement)(_react.Fragment, null, (0, _lodash.join)(mergedChoices, ','));
};
var _default = exports.default = DropdownMergeTag;
//# sourceMappingURL=merge-tag.js.map